export const Colors = {
    LIGHT_BLUE: "#18AEEB",
    ORANGE: "#EA9B18",
    PLUM: "#A2385C",
    BLUE: "#106FCB",
    GREEN: "#448D7C",
}